<template>
  <div>
    <v-tabs centered v-model="tabs" icons-and-text color="accent">
      <v-tab> Generate new <v-icon>mdi-file-plus</v-icon></v-tab>
      <v-tab>History <v-icon>mdi-history</v-icon> </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item> <FlashSalesGenerate></FlashSalesGenerate> </v-tab-item>
      <v-tab-item> <FlashSalesHistory></FlashSalesHistory> </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import FlashSalesGenerate from "../FlashSales/FlashSalesGenerate.vue";
import FlashSalesHistory from "../FlashSales/FlashSalesHistory.vue";

export default {
  name: "FlashSales",
  components: {
    FlashSalesGenerate,
    FlashSalesHistory,
  },
  props: {},
  data: () => ({
    tabs: null,
  }),
  computed: {},
  methods: {},
};
</script>
